var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"order-history"},[_c('OrderHistoryTab',{attrs:{"selected":_vm.activeOrder.order}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }